import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fbea8f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Online-Preisrechner", -1))
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_address_selector = _resolveComponent("address-selector")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_sd_button = _resolveComponent("sd-button")!
  const _component_sd_popover = _resolveComponent("sd-popover")!
  const _component_app_floating = _resolveComponent("app-floating")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sla-container", [_ctx.layout === 'vertical' ? 'vertical-layout' : 'horizontal-layout']])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'control with-flexbox-separator': _ctx.withAddress })
    }, [
      (_ctx.withAddress)
        ? (_openBlock(), _createBlock(_component_address_selector, {
            key: 0,
            modelValue: _ctx.addressPromise,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addressPromise) = $event)),
            class: "address-selector",
            onNoResultsFound: _ctx.handleNoResultsFound,
            onSearch: _ctx.handleSearchChange,
            onHandleEstimateButton: _ctx.handleButtonClick,
            onHandleSelectSubmit: _ctx.handleSelectSubmit,
            onFirstMatch: _ctx.handleFirstMatch,
            "has-error": _ctx.hasError
          }, null, 8, ["modelValue", "onNoResultsFound", "onSearch", "onHandleEstimateButton", "onHandleSelectSubmit", "onFirstMatch", "has-error"]))
        : _createCommentVNode("", true),
      _createVNode(_component_sd_button, {
        class: "open-funnel",
        onClick: _ctx.handleButtonClick,
        "is-loading": _ctx.opening,
        "loading-text": "Online-Preisrechner startet"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_icon, { type: "home_valid" }),
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick", "is-loading"])
    ], 2),
    (_ctx.hasError)
      ? (_openBlock(), _createBlock(_component_sd_popover, {
          key: 0,
          class: _normalizeClass(["popover--centered-triangle error-popover", { 'popover--above': _ctx.isPopoverAbove }]),
          show: true,
          position: "bottom",
          onClose: _ctx.clearError
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1)
          ]),
          _: 1
        }, 8, ["class", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.floatingButton && !_ctx.noFloatingButton)
      ? (_openBlock(), _createBlock(_component_app_floating, {
          key: 1,
          "principal-ref": _ctx.rootElem,
          onUpdate: _ctx.floatingButtonUpdate,
          class: "floating-button"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_sd_button, {
              class: _normalizeClass(["rounded-corners", { 'has-centered-icon': _ctx.isFloatingButtonCollapsed }]),
              onClick: _ctx.handleFloatingButtonClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_icon, { type: "home_valid" }),
                (!_ctx.isFloatingButtonCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.floatingButton), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick", "class"])
          ]),
          _: 1
        }, 8, ["principal-ref", "onUpdate"]))
      : _createCommentVNode("", true)
  ], 2))
}